'use strict';

import React      from 'react';
import moment     from 'moment-timezone';
import datepicker from 'js-datepicker';

import { OnSchedUtils } from '../../utils';

import { GetAvailability }  from '../../actions/availabilityActions';

import AvailableTimes       from './AvailableTimes/AvailableTimes';
import AvailabilityDetails  from './AvailabilityDetails/AvailabilityDetails'
import AvailabilityTimezone from './AvailabilityTimezone/AvailabilityTimezone';
import WeekCalendar         from './WeekCalendar/WeekCalendar';
import AppointmentDetails from './AppointmentDetails/AppointmentDetails';


const AvailabilityCalendar = ({ element, bookAppointment, setBookingTimerMins }) => {
  const { params, options } = element;

  const initial = {
    deselected: true,
    searching: false,
    availability: {},
    date: params.startDate ? params.startDate : moment().format('YYYY-MM-DD'),
    timezoneName: params.timezoneName ? params.timezoneName : moment.tz.guess(),
  }

  const [deselected, deselect] = React.useState(initial.deselected);
  const [searching, setSearching] = React.useState(initial.searching);

  const [availability, setAvailability] = React.useState(initial.availability);
  const [date, setDate] = React.useState(initial.date);
  const [timezoneName, setTimezone] = React.useState(initial.timezoneName);
  
  React.useEffect(() => {
    OnSchedUtils.Loading(element, true, true, 'Availability');

    const picker = datepicker('#availability-calendar-input', { 
      position:'tl',
      alwaysShow: true,
      disableYearOverlay: true,
      overlayButton: 'Go to date',
      customDays: OnSchedUtils.CustomDays(element),
      customMonths: OnSchedUtils.CustomMonths(element),
      customOverlayMonths: OnSchedUtils.CustomMonths(element),
      disabledDates: [],
      onSelect: (instance, d) => OnSchedUtils.OnAvailableDaySelect({element, instance, date: d, initialDate: date, timezoneName, setDate, setAvailability}),
      onMonthChange: (instance) => OnSchedUtils.OnAvailableMonthChange(element, instance, timezoneName, setDate, setAvailability)
    })

    GetAvailability(element, date, timezoneName)
      .then(resp => 
        OnSchedUtils.HandleInitialAvailabilityLoad(element, resp, picker, setAvailability, date, setDate, setBookingTimerMins));
  }, []);

  return (
    <div 
      onClick={e => OnSchedUtils.ClickAvailabilityWindow(e, searching, setSearching, deselected, deselect)} 
      className={`AvailabilityCalendar ${options.calendarType ? options.calendarType + '-view' : 'month-view'}`}
    >
      <AppointmentDetails element={element} availability={availability} />

      <div className={`AvailabilityCalendarGrid ${OnSchedUtils.IsMonthView(element) ? '' : 'hide'}`}>
        <input id="availability-calendar-input" />
      </div>
      
      { options.calendarType === 'week' && <WeekCalendar element={element} timezoneName={timezoneName} setDate={setDate} setAvailability={setAvailability} date={date} selectDate={setDate} availability={availability} /> }
      
      <div className='TimesContainer'>
        <div className='AvailabilityDetails'>
          <AvailabilityTimezone 
            element={element} 
            date={date} 
            setAvailability={setAvailability} 
            timezoneName={timezoneName} 
            searching={searching} 
            setSearching={setSearching} 
            setTimezone={setTimezone} 
          />
          
          <AvailabilityDetails element={element} availability={availability} />
        </div>
        
        <AvailableTimes 
          element={element}
          date={date}
          bookAppointment={bookAppointment}
          availableTimes={[]}
          availability={availability}
          deselect={deselect} 
          deselected={deselected} 
        />
      </div>
    </div>
  )
}

export default AvailabilityCalendar;
